export default __webpack_public_path__ + "static/media/it930-a033-2.e31b9f19.jpg";